import React, { lazy, Suspense } from 'react';
import {  useSelector } from 'react-redux';
import { Route, Switch } from 'react-router-dom';

import { selectIsFetchingMusic } from './redux/music/music.selector'; 

import Loader from './components/loader/loader.component';

import { GlobalStyles } from './global-styles';

import { AppContainer } from './App.style';
// import Music from './components/music/music.component';
import AudioPlayer from './components/howler/howler.component';

const HomePage = lazy(() => import('./page/home/home.component'));
const PicturePage = lazy(() => import('./page/picture-page/picture-page.component'));

const App = () => {
	const isFetchingMusic = useSelector(selectIsFetchingMusic)

    return (
        <AppContainer>
            <GlobalStyles />
            <Switch>
                <Suspense fallback={<Loader />}>
                    <Route exact path='/' component={HomePage} />
		            <Route path='/Bao-Chau' render={() => <PicturePage />} />
                    <Route path='/Bac-Lieu' render={() => <PicturePage />} />
		            <Route path='/Ha-Tien' render={() => <PicturePage />} />
                    <Route path='/Hon-son' render={() => <PicturePage />} />
                    <Route path='/Nam-Du' render={() => <PicturePage />} />
                    <Route path='/Da-Lat' render={() => <PicturePage />} />
                    <Route path='/' render={() => <AudioPlayer />} />
                </Suspense>
            </Switch>
        </AppContainer>
    );
};

export default App;
